import LocationFilter from './LocationFilter.component';

export default LocationFilter;